
/**
 * <auto-generated>
 *     This code was generated by a tool.
 *
 *     Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.
 * </auto-generated>
 */ 

export const Components = { 
    TemplateIds: {
        
        Accordion : "146415CB1C3B4064A81DB9C9C2025D1C",
        AccordionFolder : "169E4FF15C234FCB9E2535372C4F44D5",
        AlertBanner : "71FC0588CC564DA9A3EE5038ED5F414E",
        AlertBannerFolder : "ABA19475176748269080E05F4EF034EF",
        Banner : "41C29C2B56044E6A8ABF35E715108F22",
        BannerFolder : "8815A8F0E2004250B5E3621A592391E3",
        CTInstructions : "036F04E683DB46CF935011FD2CFD43AC",
        CalloutCard : "DF0E46B5830E4855BC018B773695DE7A",
        CalloutCardFolder : "A6EC775B5F88480BBD5CF3EA25624E4B",
        CardCollection : "01EFAE29A4514FE0AEE02C9C276B08D6",
        CardCollectionFolder : "F4E34B6C5B554C42B0143707A07EBB8F",
        CenterListingByType : "200FAD4D1948495ABA2423E2076463D5",
        ChecklistBlock : "CF92B906276043CF85FEC07F94EAA50A",
        ChecklistBlockFolder : "B2D810E014584BA3B75D7677EDD3C233",
        ColumnLayout : "A0BE2879742843AD971C95F97FF8F4E6",
        ContentBlock : "EDDC9C1705E042D08453F75D6044CD77",
        ContentBlockFolder : "5EC5D11886AB4E90B8F4421C8C9190D1",
        DocumentList : "459ADC01BF7B46C08F1CA425B45E64B5",
        DynamicLinkList : "3F96720DBA234F57B92FD990997D9301",
        EmployeeBlogListing : "9655544EA99E4C459296DD3061AC721E",
        EventListing : "278478B8EBBE4D1BAB176F694E5B4C2F",
        Footer : "4ED9895DFDCB5B9D8E398F86DCCF6B86",
        FormWrapper : "B9FD55C2A3B3416D9EB46F74FDAC7133",
        FormWrapperFolder : "531C5BB41120413EBF6780BAFE5C11F4",
        Header : "92969004BA7D5294B975599E32AC3C2B",
        HeroCarousel : "5923D66CE3DA4BDE946524C4250F473F",
        HeroCarouselFolder : "5342B9C1A43D424EBB8023B3A432DB56",
        HomepageHero : "A8A336CB07774CF28156449F515D3CA1",
        HomepageHeroNrc : "F9A63981BA794AD3ACB6A8DDE3817A02",
        IFrame : "07B7BA2464704C4D9BFD93DC1ECD93D4",
        IFrameFolder : "20302F4A2A5A45458B685ED0DD953CB2",
        IconItem : "616985EF2B334BCB896E0AB374300295",
        IconPanel : "7FB172064C1B4353A89AA94D528AE9D6",
        ImageBlock : "7A91F21CD25B44448F5339135057F9C1",
        ImageFolder : "941E3862C5514AF18E4821C597E579DF",
        ManualLinkList : "196E2E05CBA9446F93818A6347B6E244",
        ManualLinkListFolder : "0FA91ED412AD4E498356C53F92272A9A",
        PageCard : "B61F292C1DC9431D9C54A0EE78AF038C",
        PageCardFolder : "B97470E06A1C4D8F9A89154C480C89C9",
        PageHero : "F048C443014E4A81993581D0FC68A6F3",
        PageSection : "68D3259E1ED2436AAD5C67730F08BFDE",
        PublicisHeader : "B1D5370490A74616A6441FC4B131C115",
        PullQuote : "532478DBA7F0425F86690D5D437D1F23",
        PullQuoteFolder : "69EAF3E2964548BA8815CEA4B2E187F5",
        QuickLinks : "D3177EEEC0FE43E0AA808E34CF45BA1B",
        QuickLinksItem : "F7984A66D06D45AE8A66D918C2BFD061",
        QuickLinksItemList : "D1665AEF833C41C3956B3A667D3B41C7",
        QuickLinksListFolder : "D059398DE43F44E4BAA45F283939D55B",
        RecentNetworkAnnouncements : "E62A481A801A489C8E58A5391C80B445",
        RoundImageCarousel : "469E78CE58644FB6B932233D1D616DCD",
        RoundImageCarouselFolder : "B6BC75AE6DDF44D982F6265EA023AFCD",
        SalesForceColumnListFolder : "60F5610E46EC4AAA9159E107496CA474",
        StatItem : "F208CAB11DB446A6A2DC92BDF5932618",
        Stats : "17A8D4F724324860911CBA1EB19DD474",
        Table : "EA6CD3FF3C954300BF1F678EA36144B5",
        TableColumnFolder : "8064F1CFA2C546F090E806E97DCEF5C0",
        TableFolder : "D8B85D2B278B4AE7A09FA2C0B70F3BE9",
        TableRowFolder : "8F0A403F10C5429980F60EA79EC0D8F3",
        Tabs : "ECC7E552B8204BEF82E83B46BBB60F5B",
        TabsFolder : "501703918AA048A5B68F3FA84C37633A",
        Timeline : "A58EC3CD4435436E9E931BA74F5528BD",
        TimelineFolder : "149914219BF24CD6910B22B584854BE0",
        Video : "4C3FDC92BCB444F5819A701BB98413D1",
        VideoComponentFolder : "E1727FFB36884309B60604B1546A3CA0",
        VideoFolder : "7B2F9D0416934777BE32ADF4E91810D6",
        VideoGallery : "35AAE763AA3D4A3DA2A075BDE9B666DD",
        VideoGalleryFolder : "1362512996264272965E53C57E804C6B"    
    }
}


